import {get} from 'lodash';

import {ALL_TASKS} from '/enum/clientJourneyTasks.enum';

export const getClientJourneyAllTasks = (
  state = {},
  // eslint-disable-next-line @typescript-eslint/no-unused-vars
  {clientId, allTasks}: any,
) => {
  return {
    ...state,
    clientJourneyTasks: {
      ...get(state, 'clientJourneyTasks', {}),
      [ALL_TASKS]: allTasks,
    },
  };
};
